import { ThemeProvider, useTheme } from 'styled-components'

import { ThemeContext } from './theme'

export const ThemeWrapper: React.FC = ({ children }) => {
  const currentTheme = useTheme()

  return currentTheme ? (
    <>{children}</>
  ) : (
    <ThemeContext.Consumer>
      {contextTheme =>
        contextTheme ? <ThemeProvider theme={contextTheme}>{children}</ThemeProvider> : <>{children}</>
      }
    </ThemeContext.Consumer>
  )
}
